export const generateCookieParams = (env, currentNetwork) => {
  const paymentMethod = currentNetwork.network_configuration.payment_gateway;
  const hasPaymentAccount =
    currentNetwork.network_configuration.has_payment_account;
  const amplitudeIsEnabled =
    currentNetwork?.features?.amplitude?.config.amplitude_enabled;
  const linkedInIsEnabled =
    currentNetwork.network_configuration.linked_in_is_enabled;
  const twitterIsEnabled =
    currentNetwork.network_configuration.twitter_is_enabled;
  const facebookIsEnabled =
    currentNetwork.network_configuration.facebook_is_enabled;
  const hasGoogleAnalyticsTracking =
    currentNetwork.network_configuration.has_google_analytics_tracking;

  const customCookies = currentNetwork?.features?.cookies?.config?.cookies;

  return {
    env,
    paymentMethod,
    hasPaymentAccount,
    amplitudeIsEnabled,
    linkedInIsEnabled,
    customCookies,
    twitterIsEnabled,
    facebookIsEnabled,
    hasGoogleAnalyticsTracking,
  };
};
